import { MediaHandler } from './styled-media-helper';

/**
 * @deprecated
 * @common/theme/design-system/breakpoints
 */
export const breakpointSizes = {
  smallest: 320,
  small: 360,
  dashboardSmall: 400,
  smallMedium: 468,
  medium: 600,
  phoneLandscape: 736,
  columnLayoutWidth: 768,
  mediumLarge: 920,
  large: 1024,
  topBarMedium: 1100,
  ipadPro10: 1112,
  minPreviewWidth: 1200,
  minReportWidth: 1300,
  topBarFull: 1315,
  xLarge: 1400,
  xxLarge: 1600,
  xxxLarge: 1800,
  ultraWide: 2560,
  embed: 650,
  sm: 500,
};

/**
 * @deprecated
 * @common/theme/design-system/breakpoints
 */
export const breakpointLandscapeSizes = {
  verySmall: 568,
  small: 667,
  smallMedium: 812,
  medium: 896,
};

/**
 * @deprecated
 * @common/theme/design-system/breakpoints
 */
export const iphoneXLandscapeWidth = '812px';

/**
 * @deprecated
 * @common/theme/design-system/breakpoints
 */
export const mediaHandler = new MediaHandler(breakpointSizes);

/**
 * @deprecated
 * @common/theme/design-system/breakpoints
 */
export const breakpoints = {
  smallest: 'smallest',
  small: 'small',
  dashboardSmall: 'dashboardSmall',
  smallMedium: 'smallMedium',
  medium: 'medium',
  columnLayoutWidth: 'columnLayoutWidth',
  mediumLarge: 'mediumLarge',
  large: 'large',
  topBarMedium: 'topBarMedium',
  ipadPro10: 'ipadPro10',
  topBarFull: 'topBarFull',
  minPreviewWidth: 'minPreviewWidth',
  minReportWidth: 'minReportWidth',
  xLarge: 'xLarge',
  xxLarge: 'xxLarge',
  xxxLarge: 'xxxLarge',
  ultraWide: 'ultraWide',
  embed: 'embed',
  phoneLandscape: 'phoneLandscape',
  sm: 'sm',
};

/**
 * @deprecated
 * @common/theme/design-system/breakpoints
 */
export const breakpointsQueries = {
  belowColumnLayout: `(max-width: ${breakpointSizes.columnLayoutWidth - 1}px)`,
};

/**
 * @deprecated
 * @common/theme/design-system/breakpoints
 */
export const orientations = {
  portrait: 'portrait',
  landscape: 'landscape',
};
